import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const reducedMotion = window.matchMedia(
  "(prefers-reduced-motion: reduce)",
).matches;

if (!reducedMotion) {
  document.querySelectorAll(".image-text").forEach((section) => {
    const media = section.querySelector(".image-text__media");
    const body = section.querySelector(".image-text__body");

    if (!media || !body) {
      return;
    }

    const mediaXFrom = section.classList.contains("image-text--image-left")
      ? -48
      : 48;
    const bodyXFrom = section.classList.contains("image-text--image-left")
      ? 48
      : -48;

    gsap.context(() => {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: section,
          start: "top 85%",
          toggleActions: "play none none none",
        },
        defaults: { duration: 1, ease: "power2.out", force3D: true },
      });

      tl.from(media, { autoAlpha: 0, x: mediaXFrom }, 0).from(
        body,
        { autoAlpha: 0, x: bodyXFrom },
        0.1,
      );
    }, section);
  });
}
